import { CLEAR_PRESET, FETCH_PRESETS, SELECT_PRESET, APPLY_PRESET } from './ActionTypes';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
import * as PresetClient from '../api/PresetClient';
const createAction = (type, payload) => Object.assign({
  type
}, payload);
export const fetchPresets = themePath => {
  return dispatch => {
    dispatch(createAction(FETCH_PRESETS, {
      requestStatus: RequestStatusTypes.PENDING
    }));
    return PresetClient.fetchPresets(themePath).then(response => {
      dispatch(createAction(FETCH_PRESETS, {
        requestStatus: RequestStatusTypes.SUCCEEDED,
        results: response.results
      }));
      return response.results;
    }, error => {
      dispatch(createAction(FETCH_PRESETS, {
        requestStatus: RequestStatusTypes.FAILED,
        error
      }));
      throw error;
    });
  };
};
export const applyPreset = (themePath, presetId) => {
  return dispatch => {
    dispatch(createAction(APPLY_PRESET, {
      requestStatus: RequestStatusTypes.PENDING
    }));
    return PresetClient.applyPreset(themePath, presetId).then(response => {
      dispatch(createAction(APPLY_PRESET, {
        requestStatus: RequestStatusTypes.SUCCEEDED,
        activeThemePresetId: response.activeThemePresetId
      }));
      return response;
    }, error => {
      dispatch(createAction(APPLY_PRESET, {
        requestStatus: RequestStatusTypes.FAILED,
        error
      }));
      throw error;
    });
  };
};
export const selectPreset = selectedThemePresetId => {
  return dispatch => {
    dispatch(createAction(SELECT_PRESET, {
      selectedThemePresetId
    }));
  };
};
export const clearPreset = () => {
  return dispatch => {
    dispatch(createAction(CLEAR_PRESET, {}));
  };
};